import { selectTagsForOrderMap, selectTagsForPersonMap } from 'entities/tags';
import { FC, Fragment } from 'react';
import { useAppSelector } from 'shared/lib/store';
import { TagCard } from 'shared/ui/cards/tagCard';
import { Flex } from 'shared/ui/flex';

interface OrderTagsShortProps {
	tags?: string[];
	forOrder?: boolean;
}

export const OrderTagsShort: FC<OrderTagsShortProps> = ({
	tags,
	forOrder = false,
}) => {
	const tagsForOrder = useAppSelector(selectTagsForOrderMap);
	const tagsForPerson = useAppSelector(selectTagsForPersonMap);

  if (!tags || !tags.length) return null;

  const typographyProps = {
    whiteSpace: 'nowrap',
  }

	return (
		<Fragment>
			{((tags && tags.length > 0)) && (
				<>
					<Flex $gap="6px" $margin="4px 0 0 0">
						{tags?.map(tag => {
							let tagValue;
							if (forOrder) {
								tagValue = tagsForOrder.get(tag);
							} else {
								tagValue = tagsForPerson.get(tag);
							}

							const tagColor = tagValue?.color || '#577CF0';

							return (
								<TagCard
									key={tag}
									name={tag}
									border={tagColor}
									bg={tagColor}
									outputCloseButton={false}
                  typographyProps={typographyProps}
								/>
							);
						})}
					</Flex>
				</>
			)}
		</Fragment>
	);
};
